export default function () {
  return {
    // cui or wui
    concept: null,
    // query, reddit...
    content: null,
    // List of nGrams and meta data
    nGrams: [],
    nGramsMeta: {},
    // Selected nGrams for assigning
    nGramsSelection: [],
    // Expanded items
    expanded: [],
    // Toggle Query/Mesh Panel
    showMeshPanel: false,
    // CUI or WUI details (info)
    conceptDetails: {},
    // Selected CUI or WUI as a trigger for Queries load
    selectedConcept: {
      term: '',
      id: '',
      code: ''
    },
    //
    conceptQueries: [],
    conceptQueriesMeta: {},
    expandedConceptQueries: [],
    // Selected CUIS (for Mesh linking)
    cuisSelection: [],
    // Selected Queries
    queriesSelection: [],
    // Actions
    appliedQueries: [],
    linkedMeshes: [],
    frozenPanels: []
  };
}